import NOC from '../const/index';

// -----------------------------------------------------------------------------
// ロール番号関連
// -----------------------------------------------------------------------------
/**
 * アカウント管理者か？
 */
export function isRoleAdmin(role: number): boolean {
  return role == NOC.SETTING.ROLE.VALUE.ADMIN;
}

/**
 * 労務管理者か？
 */
export function isRoleManager(role: number |undefined): boolean {
  return role == NOC.SETTING.ROLE.VALUE.MANAGER;
}

/**
 * アカウント管理者または労務管理者か？
 */
export function isRoleAdminOrManager(role: number): boolean {
  return isRoleAdmin(role) || isRoleManager(role);
}

/**
 * 一般ユーザーか？
 */
export function isRoleGeneral(role: number | undefined): boolean {
  return role == NOC.SETTING.ROLE.VALUE.GENERAL;
}

/**
 * 労務管理者または一般ユーザか？
 */
export function isRoleManagerOrGeneral(role: number | undefined): boolean {
  return isRoleManager(role) || isRoleGeneral(role);
}

/**
 * 招待ユーザか？
 * REMOLABO-1138 労務管理者と一般ユーザ
 */
export function isRoleInvited(role: number | undefined): boolean {
  return isRoleManagerOrGeneral(role);
}

// -----------------------------------------------------------------------------
// ロールビットフラッグ関連
// -----------------------------------------------------------------------------
// ロールビットフラグ
export const ROLE_FLAG_ADMIN = getRoleBitFlag(NOC.SETTING.ROLE.VALUE.ADMIN);      // アカウント管理者
export const ROLE_FLAG_MANAGER = getRoleBitFlag(NOC.SETTING.ROLE.VALUE.MANAGER);  // 労務管理者
export const ROLE_FLAG_GENERAL = getRoleBitFlag(NOC.SETTING.ROLE.VALUE.GENERAL);  // 一般
// ロールビットフラグ（複合）
export const ROLE_FLAG_ALL = ROLE_FLAG_ADMIN + ROLE_FLAG_MANAGER + ROLE_FLAG_GENERAL; // 全権限
export const ROLE_FLAG_ADMIN_OR_MANAGER = ROLE_FLAG_ADMIN + ROLE_FLAG_MANAGER; // アカウント管理者、労務管理者

/**
 * roleからビットフラグの生成。
 * @param role ロール番号。NOC.SETTING.ROLE.VALUE.*
 * @returns
 */
export function getRoleBitFlag(role: number): number {
  if ( role <= 0 || role >= 32 ) {
    console.error(`不正なrole(${role})を指定しています。`);
    return 0;
  }
  // bit演算を置き換え 1 << (role - 1)
  return Math.pow(2, role - 1);
}

/**
 * 権限のフラグとの比較bit演算(lint警告回避用)
 * @param flag アクセスが許可される権限
 * @param role 検証する権限
 * @returns アクセスが許可されるかどうか
 */
export function isAllowRoleBitFlag(flag: number, role: number): boolean {
  // bit演算を置き換え flag & role;
  // ユーザーが複数の権限を持たない前提の簡易的処理
  return (flag / role) % 2 >= 1;
}
